// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Mechanics from './Mechanics';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Mechanics);
